import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-vehicle-container',
    templateUrl: './gdo-vehicle-container.component.html',
    styleUrls: ['./gdo-vehicle-container.component.scss'],
    standalone: false
})
export class GdoVehicleContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
